import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ColorSetClass;
function ColorSet() {
  if (ColorSetClass === VOID) {
    class $ {
      constructor(name, dark, main, light1, light2, light3) {
        this.vg9_1 = name;
        this.wg9_1 = dark;
        this.xg9_1 = main;
        this.yg9_1 = light1;
        this.zg9_1 = light2;
        this.aga_1 = light3;
      }
      rjn() {
        return listOf([this.wg9_1, this.xg9_1, this.yg9_1, this.zg9_1, this.aga_1]);
      }
      toString() {
        return 'ColorSet(name=' + this.vg9_1 + ', dark=' + this.wg9_1.toString() + ', main=' + this.xg9_1.toString() + ', light1=' + this.yg9_1.toString() + ', light2=' + this.zg9_1.toString() + ', light3=' + this.aga_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.vg9_1);
        result = imul(result, 31) + this.wg9_1.hashCode() | 0;
        result = imul(result, 31) + this.xg9_1.hashCode() | 0;
        result = imul(result, 31) + this.yg9_1.hashCode() | 0;
        result = imul(result, 31) + this.zg9_1.hashCode() | 0;
        result = imul(result, 31) + this.aga_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ColorSet()))
          return false;
        if (!(this.vg9_1 === other.vg9_1))
          return false;
        if (!this.wg9_1.equals(other.wg9_1))
          return false;
        if (!this.xg9_1.equals(other.xg9_1))
          return false;
        if (!this.yg9_1.equals(other.yg9_1))
          return false;
        if (!this.zg9_1.equals(other.zg9_1))
          return false;
        if (!this.aga_1.equals(other.aga_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ColorSet');
    ColorSetClass = $;
  }
  return ColorSetClass;
}
var AppColorsClass;
function AppColors() {
  if (AppColorsClass === VOID) {
    class $ {
      constructor() {
        AppColors_instance = this;
        this.cfz_1 = new (ColorSet())('purple', Companion_getInstance().acz('210840'), Companion_getInstance().acz('421976'), Companion_getInstance().acz('715298'), Companion_getInstance().acz('C0B3D2'), Companion_getInstance().acz('EDEAF3'));
        this.dfz_1 = new (ColorSet())('green', Companion_getInstance().acz('005526'), Companion_getInstance().acz('00ab4d'), Companion_getInstance().acz('50C685'), Companion_getInstance().acz('A1E1BD'), Companion_getInstance().acz('E9F8F0'));
        this.efz_1 = new (ColorSet())('yellow', Companion_getInstance().acz('B48400'), Companion_getInstance().acz('f2ba1c'), Companion_getInstance().acz('F7D575'), Companion_getInstance().acz('FBEBBC'), Companion_getInstance().acz('FEFAED'));
        this.ffz_1 = new (ColorSet())('neutrals', Companion_getInstance().acz('201F1F'), Companion_getInstance().acz('8D8B8B'), Companion_getInstance().acz('D6D6D6'), Companion_getInstance().acz('F0F1F1'), Companion_getInstance().acz('FAFAFA'));
        this.gfz_1 = Companion_getInstance().zcy(5526612);
        this.hfz_1 = new (ColorSet())('red', Companion_getInstance().acz('7C1400'), Companion_getInstance().acz('F72700'), Companion_getInstance().acz('FA755C'), Companion_getInstance().acz('FCA899'), Companion_getInstance().acz('FFF2F0'));
        this.ifz_1 = new (ColorSet())('yellow', Companion_getInstance().acz('B48400'), Companion_getInstance().acz('f2ba1c'), Companion_getInstance().acz('F7D575'), Companion_getInstance().acz('FBEBBC'), Companion_getInstance().acz('FEFAED'));
        this.jfz_1 = new (ColorSet())('blue', Companion_getInstance().acz('263062'), Companion_getInstance().acz('5271ff'), Companion_getInstance().acz('92A3F1'), Companion_getInstance().acz('C8D1F8'), Companion_getInstance().acz('EFF2FF'));
        this.kfz_1 = new (ColorSet())('purple', Companion_getInstance().acz('4F1994'), Companion_getInstance().acz('7b22ed'), Companion_getInstance().acz('AA6FF6'), Companion_getInstance().acz('D1B3F8'), Companion_getInstance().acz('E9E1F4'));
        this.lfz_1 = Companion_getInstance().acz('02843D');
      }
    }
    initMetadataForObject($, 'AppColors');
    AppColorsClass = $;
  }
  return AppColorsClass;
}
var AppColors_instance;
function AppColors_getInstance() {
  if (AppColors_instance === VOID)
    new (AppColors())();
  return AppColors_instance;
}
//region block: exports
export {
  AppColors_getInstance as AppColors_getInstance3ty7139j9u8g2,
};
//endregion

//# sourceMappingURL=AppColors.mjs.map
